import React, { useState } from "react";
import ShimmeringText from "components/chat-v2/ShimmeringText";
import { Button } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { addDoc, collection } from "firebase/firestore";
import { auth, db } from "firebaseApp";
import { useNavigate } from "react-router-dom";

export default function GenerateMenuButton({ image }) {

  const navigate = useNavigate();

  const [generating, setGenerating] = useState(false);
  const uid = auth.currentUser?.uid;

  const handleGenerateMenu = async () => {
    try {
      setGenerating(true);
      const ref = await addDoc(collection(db, "aiMenus"), {
        imageUrl: image.imageUrl,
        uid,
        status: "created",
        info: "Waiting for processing",
      });
      navigate(`/aiMenu/${ref.id}`);
    } catch(error) {
      console.log(error);
    } finally {
      setGenerating(false);
    }
  } 

  if (!image.imageUrl) {
    return <ShimmeringText>Waiting for image to upload</ShimmeringText>;
  }

  return (
    <Button
      variant="contained"
      startIcon={<AutoAwesomeIcon />}
      onClick={handleGenerateMenu}
      disabled={generating}
    >
      {generating ? "Generating..." : "Generate Menu"}
    </Button>
  );
}
